import { DELETE_PATIENT } from '../../../../actions/action-types';
import { PAGE_LIMIT } from '../../../../constants';
import { API_CALL, API_CANCEL } from '../../../../middleware/api';
import {
  ADD_MEDICINE,
  ADD_PATIENT,
  CLEAR_DEVICE_DATA,
  DELETE_TASK_HISTORY,
  DOWNLOAD_TASK_HISTORY,
  EDIT_PATIENT,
  END_TASK,
  EVENT_LIST,
  GET_CAP_DETAILS,
  GET_DEVICES,
  GET_DEVICES_DETAILS,
  GET_MEDICATIONS,
  SEARCH_MEDUCATION,
  SEARCH_MEDUCATION_BATCH,
  GET_TASKS_LIST,
  PATIENT_DETAILS,
  PATIENT_DASHBOARD_INFO,
  PATIENT_LIST,
  START_TASK,
  ADD_NOTE,
  GET_NOTES,
  EDIT_NOTE,
  UPDATE_ACTION_STATUS,
  PATIENT_BILLABLE_TIME,
  PATIENT_LIST_FOR_SUGGESTION,
  PATIENT_LIST_FOR_SUGGESTION_CLEAR,
  PATIENT_LIST_CLEAR,
  PATIENT_LIST_QUERY,
  GET_CONDITION_LIST,
  ENROLL_PATIENT,
  GET_READINGS,
  ARCHIVE_PATIENT,
  GET_SCHEDULE,
  GET_CAPS_WITHOUT_SCHEDULE,
  GET_CAP_PLOT_DATA,
  lOAD_PATIENTS,
  CONTINUE_TASK,
  SEND_WELCOME_MESSAGE,
  PATIENT_DETAILS_CLEAR,
  DOWNLOAD_NOTES_AND_ACTIONS,
  GET_SCHEDULE_NOTIFICATIONS,
  DOWNLOAD_KIT_DATA,
  DOWNLOAD_MONTHLY_SUMMARY,
  GET_AVERAGE_READINGS,
  END_ENROLLMENT,
  UNREGISTER_ENROLLMENT,
  INVITE_PATIENT_TO_PORTAL,
  GET_PATIENT_DEVICES,
  GET_PATIENT_ADHERENCE,
  GET_UNBILLED_EVIDENCES,
  DOWNLOAD_PATIENTS_EVENTS,
  SEARCH_FOR_NOTE_RECIPIENTS,
  GET_NOTE,
  EDIT_WELCOME_MESSAGE,
  REASSIGN_CARE_PROVIDER,
  GET_PROVIDER_VISIT_SUMMARY,
  GET_CARE_PROVIDED_ORGANIZATIONS,
  SET_ORG_FILTER,
  GET_READINGS_SCHEDULES,
  CREATE_READINGS_SCHEDULE,
  DELETE_READINGS_SCHEDULE,
  EDIT_READINGS_SCHEDULE,
  GET_WELCOME_MESSAGE,
  GET_TASKS_LIST_ALL,
  CREATE_CUSTOM_TASK,
  UPDATE_CUSTOM_TASK,
  UPDATE_GLOBAL_TASK_DEFAULTS,
  DELETE_CUSTOM_TASK,
  ENABLE_ORG_TASK,
  DISABLE_ORG_TASK,
  PATIENT_ELIGIBILITY_INFO,
  TRIGGER_ELIGIBILITY_CHECK,
  REFRESH_ELIGIBILITY_RESULTS,
  GET_TIMER_TASKS_LIST,
  GET_PATIENT_STATUS_COUNTS,
  GET_PATIENT_PROVIDER_OPTIONS,
  MOVE_TO_NOT_ENROLLED,
  CLEAR_NOT_ENROLLED_STATUS,
  GET_PATIENT_TEXT_OPT_OUT_STATUS,
  UPDATE_PATIENT_TEXT_OPT_OUT_STATUS,
  CLEAR_PATIENT_BILLABLE_TIME,
  GET_ENROLLMENT_STATUS_HISTORY,
  TASK_HISTORY_LIST,
  TASK_HISTORY_FILTER_OPTIONS,
  UPDATE_TIMER_TASK,
  ADD_TIMER_TASK,
  DELETE_TIMER_TASK,
  GET_ANNOTATIONS,
  ADD_ANNOTATION,
  EDIT_ANNOTATION,
  DELETE_ANNOTATION,
  GET_ANNOTATION,
  SET_TIMER_DEFAULT_TASK,
  GET_TIMER_DEFAULT_TASK,
  GET_TASKS_LIST_ALL_ORGLESS,
  GET_PATIENT_MONITORING_REPORT,
  REGISTER_ENROLLMENT,
  ENROLL_ACCESS_ENROLLMENT,
  POST_MANUAL_VITALS,
  RESOLVE_PRIMARY_CARE_PROVIDER,
  SEARCH_EXTERNAL_PROVIDERS,
  UPDATE_PRIMARY_CARE_PROVIDER,
  UPDATE_REFERRING_PROVIDER,
} from './constants';

export const actions = {
  searchMeducation: query => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/meducation/medsearch',
      params: { qs: query },
    },
    type: SEARCH_MEDUCATION,
  }),

  searchMeducationBatch: queries => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/meducation/medsearch/batch',
      params: { qs: queries },
    },
    type: SEARCH_MEDUCATION_BATCH,
  }),

  // `latest`: the patients table (tab switch, filters, refetch after a save) wants only the
  // newest list; other callers (widgets, modals) must not cancel it, so it is opt-in.
  // The patients table's list: only the table dispatches it, and only its newest request may
  // fill the table state (tab switch, filters, refetch after a save).
  getPatients: pageRequest => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/patients/list',
      params: { ...pageRequest, limit: pageRequest.limit || PAGE_LIMIT },
      latest: true,
    },
    type: PATIENT_LIST,
  }),
  // The same endpoint for callers that only read the response (e.g. dashboard counts). Its own
  // action type keeps their results out of the patients table state.
  queryPatients: pageRequest => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/patients/list',
      params: { ...pageRequest, limit: pageRequest.limit || PAGE_LIMIT },
    },
    type: PATIENT_LIST_QUERY,
  }),
  loadPatients: pageRequest => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/patients/list',
      params: { ...pageRequest, limit: pageRequest.limit || PAGE_LIMIT },
    },
    type: lOAD_PATIENTS,
  }),
  getPatientsForSuggestion: pageRequest => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/patients/list',
      params: { ...pageRequest, limit: pageRequest.limit || 500 },
    },
    type: PATIENT_LIST_FOR_SUGGESTION,
  }),
  clearPatients: () => ({ type: PATIENT_LIST_CLEAR, [API_CANCEL]: { latest: PATIENT_LIST } }),
  clearPatientsForSuggestion: () => ({ type: PATIENT_LIST_FOR_SUGGESTION_CLEAR }),

  getPatientEvent: (pageRequest, patientId) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/patient/${patientId}/events`,
      params: { limit: PAGE_LIMIT, ...pageRequest },
    },
    type: EVENT_LIST,
  }),
  getPatientInfo: patientId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/patient/${patientId}/`,
    },
    type: PATIENT_DETAILS,
  }),
  updatePrimaryCareProvider: (patientId, provider) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/patients/${encodeURIComponent(patientId)}/primary-care-provider`,
      data: { provider },
    },
    type: UPDATE_PRIMARY_CARE_PROVIDER,
  }),
  updateReferringProvider: (enrollmentId, provider) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/billing/care_management/${encodeURIComponent(enrollmentId)}/referring-provider`,
      data: { provider },
    },
    type: UPDATE_REFERRING_PROVIDER,
  }),
  getEnrollmentStatusHistory: (patientId, sortType = 'descending') => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/patient/${patientId}/enrollment-status-history`,
      params: { sortType },
    },
    type: GET_ENROLLMENT_STATUS_HISTORY,
  }),
  clearPatientInfo: () => ({ type: PATIENT_DETAILS_CLEAR }),
  getPatientDahsboardInfo: patientId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/${patientId}/patient-info`,
    },
    type: PATIENT_DASHBOARD_INFO,
  }),
  getPatientLastReadings: patientId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/${patientId}/last-readings`,
    },
    type: PATIENT_DASHBOARD_INFO,
  }),
  getPatientBillableTime: patientId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/patient/${patientId}/billable-time`,
    },
    type: PATIENT_BILLABLE_TIME,
  }),
  clearPatientBillableTime: () => ({ type: CLEAR_PATIENT_BILLABLE_TIME }),
  getMedications: patientId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/${patientId}/medications`,
    },
    type: GET_MEDICATIONS,
  }),
  addMedicine: data => ({
    [API_CALL]: {
      endpoint: `portal/schedules`,
      method: 'post',
      data,
    },
    type: ADD_MEDICINE,
  }),

  postManualVitals: (patientId, payload) => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/${patientId}/manual_vitals`,
      method: 'post',
      data: payload,
    },
    type: POST_MANUAL_VITALS,
  }),

  addPatient: data => ({
    [API_CALL]: {
      endpoint: `portal/patients/add`,
      method: 'post',
      data,
    },
    type: ADD_PATIENT,
  }),

  editPatient: (data, patientId) => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/${patientId}/`,
      method: 'PUT',
      data,
    },
    type: EDIT_PATIENT,
  }),

  moveToNotEnrolled: (patientId, enrollmentId, data) => ({
    [API_CALL]: {
      endpoint: enrollmentId
        ? `portal/patients/patient/${patientId}/${enrollmentId}/not-enrolled`
        : `portal/patients/patient/${patientId}/not-enrolled`,
      method: 'POST',
      data,
    },
    type: MOVE_TO_NOT_ENROLLED,
  }),

  clearNotEnrolled: (patientId, enrollmentId) => ({
    [API_CALL]: {
      endpoint: enrollmentId
        ? `portal/patients/patient/${patientId}/${enrollmentId}/not-enrolled`
        : `portal/patients/patient/${patientId}/not-enrolled`,
      method: 'DELETE',
      data: {
        patient_id: patientId,
      },
    },
    type: CLEAR_NOT_ENROLLED_STATUS,
  }),

  getTaskHistoryList: pageRequest => ({
    [API_CALL]: {
      endpoint: `portal/billing/work_log/actions`,
      method: 'get',
      params: { limit: PAGE_LIMIT, ...pageRequest },
    },
    type: TASK_HISTORY_LIST,
  }),

  getTaskHistoryFilterOptions: pageRequest => ({
    [API_CALL]: {
      endpoint: `portal/billing/work_log/timers/filter_options`,
      method: 'get',
      params: pageRequest,
    },
    type: TASK_HISTORY_FILTER_OPTIONS,
  }),

  editTimerTask: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/work_log/timer/edit',
      method: 'put',
      data,
    },
    type: UPDATE_TIMER_TASK,
  }),

  addTimerTask: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/work_log/add',
      method: 'post',
      data,
    },
    type: ADD_TIMER_TASK,
  }),

  deleteTimerTask: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/work_log/timer/delete',
      method: 'put',
      data,
    },
    type: DELETE_TIMER_TASK,
  }),

  downloadTaskHistory: pageRequest => ({
    [API_CALL]: {
      endpoint: `portal/billing/work_log`,
      method: 'get',
      params: { ...pageRequest, format: 'csv' },
      responseType: 'blob',
    },
    type: DOWNLOAD_TASK_HISTORY,
  }),

  downloadTaskHistoryXlsx: pageRequest => ({
    [API_CALL]: {
      endpoint: `portal/billing/work_log`,
      method: 'get',
      params: { ...pageRequest, format: 'xlsx' },
      responseType: 'blob',
    },
    type: DOWNLOAD_TASK_HISTORY,
  }),

  getDevices: (pageRequest, patientId) => ({
    [API_CALL]: {
      endpoint: `portal/patients/devices/${patientId}/list`,
      method: 'get',
      params: { ...pageRequest, limit: pageRequest.limit || PAGE_LIMIT },
      latest: true,
    },
    type: GET_DEVICES,
  }),

  getPatientDevices: (pageRequest, patientId) => ({
    [API_CALL]: {
      endpoint: `portal/patients/devices/${patientId}/list`,
      method: 'get',
      params: { ...pageRequest, limit: pageRequest.limit || PAGE_LIMIT },
    },
    type: GET_PATIENT_DEVICES,
  }),

  getDeviceDetails: (pageRequest, patientId, capId, deviceType, deviceId) => ({
    [API_CALL]: {
      endpoint: `portal/v1/hubs/${capId}/devices/${deviceId}/events`,
      method: 'get',
      params: { ...pageRequest, limit: PAGE_LIMIT },
    },
    type: GET_DEVICES_DETAILS,
  }),

  getCapDetails: (id, pageRequest) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/esi/v1/caps/' + id,
      params: pageRequest,
    },
    type: GET_CAP_DETAILS,
  }),

  deletePatient: (deleteData, id) => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/delete/`,
      method: 'POST',
      data: deleteData,
    },
    type: DELETE_PATIENT,
    id: id,
  }),

  deleteTaskHistory: (data, callAfterSuccess = []) => ({
    [API_CALL]: {
      endpoint: 'portal/billing/work_log/delete',
      method: 'PUT',
      data,
      callAfterSuccess,
    },
    type: DELETE_TASK_HISTORY,
  }),

  startTask: data => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/billing/work_log/new`,
      data,
    },
    type: START_TASK,
  }),

  continueTask: data => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/billing/work_log/continue`,
      data,
    },
    type: CONTINUE_TASK,
  }),

  endTask: data => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/billing/work_log/stop`,
      data,
    },
    type: END_TASK,
  }),

  getTasks: (orgId, { latest = false } = {}) => ({
    [API_CALL]: {
      endpoint: `/portal/billing/work_log/work_types/${orgId}`,
      method: 'get',
      latest: latest && GET_TASKS_LIST,
    },
    type: GET_TASKS_LIST,
  }),
  getTimerTasks: orgId => ({
    [API_CALL]: {
      endpoint: `portal/billing/work_log/timer_work_types/${orgId}`,
      method: 'get',
    },
    type: GET_TIMER_TASKS_LIST,
  }),
  // One task at a time: unlike replacing the whole enabled-task list, concurrent edits of
  // different tasks can't overwrite each other.
  enableOrgTask: (orgId, taskId) => ({
    [API_CALL]: {
      endpoint: `/portal/billing/work_log/work_types/${orgId}/tasks/${taskId}`,
      method: 'put',
    },
    type: ENABLE_ORG_TASK,
  }),
  disableOrgTask: (orgId, taskId) => ({
    [API_CALL]: {
      endpoint: `/portal/billing/work_log/work_types/${orgId}/tasks/${taskId}`,
      method: 'delete',
    },
    type: DISABLE_ORG_TASK,
  }),
  getAllTasks: orgId => ({
    [API_CALL]: {
      endpoint: `portal/billing/work_log/all_work_types/${orgId}`,
      method: 'get',
    },
    type: GET_TASKS_LIST_ALL,
  }),
  getAllTasksOrgless: () => ({
    [API_CALL]: {
      endpoint: `portal/billing/work_log/all_work_types`,
      method: 'get',
    },
    type: GET_TASKS_LIST_ALL_ORGLESS,
  }),
  createCustomTask: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/work_log',
      method: 'post',
      data,
    },
    type: CREATE_CUSTOM_TASK,
  }),
  updateGlobalTaskDefaults: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/work_log/global_defaults',
      method: 'put',
      data,
    },
    type: UPDATE_GLOBAL_TASK_DEFAULTS,
  }),
  updateCustomTask: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/work_log',
      method: 'put',
      data,
    },
    type: UPDATE_CUSTOM_TASK,
  }),
  deleteCustomTask: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/work_log/delete',
      method: 'post',
      data,
    },
    type: DELETE_CUSTOM_TASK,
  }),
  setTimerDefaultTask: (orgId, data) => ({
    [API_CALL]: {
      endpoint: `portal/billing/work_log/timer_default_task/${orgId}`,
      method: 'put',
      data,
    },
    type: SET_TIMER_DEFAULT_TASK,
  }),
  getTimerDefaultTask: orgId => ({
    [API_CALL]: {
      endpoint: `portal/billing/work_log/timer_default_task/${orgId}`,
      method: 'get',
    },
    type: GET_TIMER_DEFAULT_TASK,
  }),

  clearDevice: () => ({
    type: CLEAR_DEVICE_DATA,
    [API_CANCEL]: { latest: GET_DEVICES },
  }),

  getNotes: patientId => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/${patientId}/notes`,
      method: 'get',
    },
    type: GET_NOTES,
  }),
  searchForNoteRecipients: search => ({
    [API_CALL]: {
      endpoint: 'portal/patients/search-for-note-recipients',
      method: 'get',
      params: { search },
    },
    type: SEARCH_FOR_NOTE_RECIPIENTS,
  }),

  addNote: (patientId, data) => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/${patientId}/note`,
      method: 'post',
      data,
    },
    type: ADD_NOTE,
  }),
  editNote: (noteId, data) => ({
    [API_CALL]: {
      endpoint: `portal/patients/note/${noteId}/edit`,
      method: 'put',
      data,
    },
    type: EDIT_NOTE,
  }),
  updateActionStatus: (noteId, actionCompleted) => ({
    [API_CALL]: {
      endpoint: `portal/patients/note/${noteId}/action-status`,
      method: 'put',
      data: { action_completed: actionCompleted },
    },
    type: UPDATE_ACTION_STATUS,
  }),
  getNote: noteId => ({
    [API_CALL]: {
      endpoint: `portal/patients/note/${noteId}/read`,
      method: 'get',
    },
    type: GET_NOTE,
  }),
  getConditions: () => ({
    [API_CALL]: {
      endpoint: `portal/patients/cohorts/conditions/summary`,
      method: 'get',
      params: { limit: 1000000 },
    },
    type: GET_CONDITION_LIST,
  }),
  enrollPatient: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/care_management/enrollment',
      method: 'PUT',
      data,
    },
    type: ENROLL_PATIENT,
  }),
  registerEnrollment: (enrollmentId, data) => ({
    [API_CALL]: {
      endpoint: `portal/billing/care_management/${enrollmentId}/register`,
      method: 'POST',
      data,
    },
    type: REGISTER_ENROLLMENT,
  }),
  enrollAccessEnrollment: (enrollmentId, data = {}) => ({
    [API_CALL]: {
      endpoint: `portal/billing/care_management/${enrollmentId}/enroll`,
      method: 'POST',
      data,
    },
    type: ENROLL_ACCESS_ENROLLMENT,
  }),
  resolvePrimaryCareProvider: patientId => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/${encodeURIComponent(patientId)}/primary-care-provider/resolve`,
      method: 'POST',
      data: {},
    },
    type: RESOLVE_PRIMARY_CARE_PROVIDER,
  }),
  searchExternalProviders: (patientId, data) => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/${encodeURIComponent(patientId)}/external-providers/search`,
      method: 'POST',
      data,
    },
    type: SEARCH_EXTERNAL_PROVIDERS,
  }),
  endEnrollment: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/care_management/leave',
      method: 'PUT',
      data,
    },
    type: END_ENROLLMENT,
  }),
  unregisterEnrollment: enrollmentId => ({
    [API_CALL]: {
      endpoint: `portal/billing/care_management/${enrollmentId}/unregister`,
      method: 'PUT',
      data: {},
    },
    type: UNREGISTER_ENROLLMENT,
  }),
  reassignCareProvider: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/care_management/care_provider',
      method: 'PUT',
      data,
    },
    type: REASSIGN_CARE_PROVIDER,
  }),
  getReadings: pageRequest => ({
    [API_CALL]: {
      endpoint: `portal/patients/multiple/last-readings`,
      method: 'get',
      params: { limit: PAGE_LIMIT, ...pageRequest },
    },
    type: GET_READINGS,
  }),
  archiveToggle: data => ({
    [API_CALL]: {
      endpoint: 'portal/patients/multiple/last-readings-archive',
      method: 'PUT',
      data,
    },
    type: ARCHIVE_PATIENT,
  }),
  getSchedule: (patientId, scheduleRootId) => ({
    [API_CALL]: {
      endpoint: `/portal/v2/patientportal/patient/${patientId}/schedules/${scheduleRootId}/chart/schedule`,
      method: 'get',
    },
    type: GET_SCHEDULE,
  }),
  getCapPlotData: (patientId, scheduleRootId, request) => ({
    [API_CALL]: {
      endpoint: `/portal/v2/patientportal/patient/${patientId}/schedules/${scheduleRootId}/chart/plot`,
      method: 'get',
      params: { ...request },
    },
    type: GET_CAP_PLOT_DATA,
  }),
  getScheduleNotifications: (scheduleId, request) => ({
    [API_CALL]: {
      endpoint: `portal/reminders/schedules/${scheduleId}/history`,
      method: 'get',
      params: { ...request },
    },
    type: GET_SCHEDULE_NOTIFICATIONS,
  }),
  getCapsWithoutSchedule: patientId => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/${patientId}/caps_without_schedule`,
      method: 'get',
    },
    type: GET_CAPS_WITHOUT_SCHEDULE,
  }),
  sendWelcomeMessage: data => ({
    [API_CALL]: {
      endpoint: 'portal/reminders/welcome_message',
      method: 'post',
      data,
    },
    type: SEND_WELCOME_MESSAGE,
  }),
  editWelcomeMessage: data => ({
    [API_CALL]: {
      endpoint: 'portal/reminders/welcome_message',
      method: 'put',
      data,
    },
    type: EDIT_WELCOME_MESSAGE,
  }),
  getWelcomeMessage: patientId => ({
    [API_CALL]: {
      endpoint: `portal/reminders/patient/${patientId}/welcome_message`,
      method: 'get',
    },
    type: GET_WELCOME_MESSAGE,
  }),
  downloadNotesAndActions: request => ({
    [API_CALL]: {
      endpoint: 'portal/patients/notes/download',
      method: 'get',
      params: request,
    },
    type: DOWNLOAD_NOTES_AND_ACTIONS,
  }),
  downloadPatientsEvents: request => ({
    [API_CALL]: {
      endpoint: 'portal/patients/events/csv',
      method: 'get',
      params: request,
    },
    type: DOWNLOAD_PATIENTS_EVENTS,
  }),
  downloadKitData: (patientId, request) => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/${patientId}/events/csv`,
      method: 'get',
      params: request,
    },
    type: DOWNLOAD_KIT_DATA,
  }),
  downloadMonthlySummary: (patientId, request) => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/${patientId}/monthly-summary`,
      method: 'get',
      params: request,
      responseType: 'blob',
    },
    type: DOWNLOAD_MONTHLY_SUMMARY,
  }),
  getAverageReadings: (patientId, dataType, request) => ({
    [API_CALL]: {
      endpoint: `portal/patients/${patientId}/average/${dataType}`,
      method: 'get',
      params: request,
    },
    type: GET_AVERAGE_READINGS,
  }),
  invitePatientToPortal: (patient_id, inviteMethod) => ({
    [API_CALL]: {
      endpoint: `portal/patients/patient/${patient_id}/portal/invite?${inviteMethod}`,
      method: 'post',
    },
    type: INVITE_PATIENT_TO_PORTAL,
  }),
  getPatientAdherence: patientId => ({
    [API_CALL]: {
      endpoint: `portal/patients/${patientId}/daily-adherence`,
      method: 'get',
    },
    type: GET_PATIENT_ADHERENCE,
  }),
  getUnbilledEvidences: patientId => {
    return {
      [API_CALL]: {
        endpoint: `portal/billing/monitoring/report/cycle-activities`,
        method: 'get',
        params: { patientId },
      },
      type: GET_UNBILLED_EVIDENCES,
    };
  },
  getProviderVisitSummary: patientId => {
    return {
      [API_CALL]: {
        endpoint: `portal/patients/patient/${patientId}/enrollment_status`,
        method: 'get',
        params: { patientId },
      },
      type: GET_PROVIDER_VISIT_SUMMARY,
    };
  },
  getCareProvidedOrganizations: () => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: `portal/billing/care_management/care_provided_orgs`,
      },
      type: GET_CARE_PROVIDED_ORGANIZATIONS,
    };
  },

  // TODO: Unused
  setOrgFilter: (userId, orgId) => ({
    type: SET_ORG_FILTER,
    userId,
    orgId,
  }),

  getReadingsSchedules: patientId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/patient/${patientId}/meas_schedules/list`,
    },
    type: GET_READINGS_SCHEDULES,
  }),

  createReadingsSchedule: (patientId, data) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/patients/patient/${patientId}/meas_schedules/add`,
      data,
    },
    type: CREATE_READINGS_SCHEDULE,
  }),

  editReadingsSchedule: (scheduleId, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/patients/meas_schedules/schedule/${scheduleId}/update`,
      data,
    },
    type: EDIT_READINGS_SCHEDULE,
  }),
  deleteReadingsSchedule: scheduleId => ({
    [API_CALL]: {
      method: 'DELETE',
      endpoint: `portal/patients/meas_schedules/schedule/${scheduleId}/delete`,
    },
    type: DELETE_READINGS_SCHEDULE,
  }),
  getPatientEligibilityInfo: patientId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/${patientId}/eligibility`,
    },
    type: PATIENT_ELIGIBILITY_INFO,
  }),
  triggerEligibilityCheck: patientId => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/patients/${patientId}/eligibility`,
    },
    type: TRIGGER_ELIGIBILITY_CHECK,
  }),
  refreshEligibilityResults: patientId => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/patients/${patientId}/eligibility/refresh`,
    },
    type: REFRESH_ELIGIBILITY_RESULTS,
  }),

  getPatientStatusCounts: pageRequest => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/patients/list',
      params: { ...pageRequest, status: 'count' },
    },
    type: GET_PATIENT_STATUS_COUNTS,
  }),
  getPatientProviderOptions: pageRequest => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/patients/list/providers',
      params: { ...pageRequest },
    },
    type: GET_PATIENT_PROVIDER_OPTIONS,
  }),

  getPatientTextOptOutStatus: patientId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `/portal/patients/patient/${patientId}/text-opt-out`,
    },
    type: GET_PATIENT_TEXT_OPT_OUT_STATUS,
  }),

  updatePatientTextOptOutStatus: (patientId, data) => ({
    [API_CALL]: {
      method: 'PATCH',
      endpoint: `/portal/patients/patient/${patientId}/text-opt-out`,
      data,
    },
    type: UPDATE_PATIENT_TEXT_OPT_OUT_STATUS,
  }),

  getAnnotations: (patientId, params) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/patient/${patientId}/annotations`,
      params,
    },
    type: GET_ANNOTATIONS,
  }),

  addAnnotation: (patientId, data) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/patients/patient/${patientId}/annotations`,
      data,
    },
    type: ADD_ANNOTATION,
  }),

  getAnnotation: (patientId, annotationId) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/patients/patient/${patientId}/annotations/${annotationId}`,
    },
    type: GET_ANNOTATION,
  }),

  editAnnotation: (patientId, annotationId, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/patients/patient/${patientId}/annotations/${annotationId}`,
      data,
    },
    type: EDIT_ANNOTATION,
  }),

  deleteAnnotation: (patientId, annotationId) => ({
    [API_CALL]: {
      method: 'DELETE',
      endpoint: `portal/patients/patient/${patientId}/annotations/${annotationId}`,
    },
    type: DELETE_ANNOTATION,
  }),

  downloadPatientsMonitoringReport: (params) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `/portal/report/monitoring_report/download`,
      params,
    },
    type: GET_PATIENT_MONITORING_REPORT,
  }),
};
